var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Pfad_2191","data-name":"Pfad 2191","d":"M0,0,8.3,8.437,16.23,0","transform":"translate(1.414 17.645) rotate(-90)","fill":"none","stroke":"#18404b","strokeLinecap":"round","strokeWidth":"2"}));
}

RightArrow.defaultProps = {"width":"11.293","height":"19.059","viewBox":"0 0 11.293 19.059"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
